import React, {Component} from 'react';
import { isEmpty } from "lodash"
import { connect } from "react-redux";

import { ListAltRounded, InsertChartOutlinedRounded, RestoreRounded, CalendarTodayRounded, QuizRounded, HomeMaxRounded, PlumbingRounded } from '@mui/icons-material';
import { BottomNavigationAction, BottomNavigation } from '@mui/material';

const PAGES = {
	// 1: "/stats",
	0: "/spendings",
	1: "/admin/dashboard",
	2: "/immos",
	3: "/salaries",
	4: "/planning",
	5: "/demands",
	// 3: "/budget"
}


class Footer extends Component {
	state = { 
		selected: ""
	}

	componentDidMount = () => {
		let selected = ""
		if ( this.props.admin ) {
			selected = 1
		} else if( this.props.spendings ){
			selected = 0
		} else if( this.props.salaries ){
			selected = 3
		} else if( this.props.planning ){
			selected = 4
		} else if( this.props.immos ){
			selected = 2
		} else if( this.props.demands ){
			selected = 5
		}
		this.setState({selected})
	}
	setValue = (e, newVal) => {
		console.log("Footer bottom nav", {newVal});
		this.props.history.push(PAGES[newVal])
	}
	render() {
		const { selected } = this.state;
		const { isAuthenticated, isAdmin, employee } = this.props.auth;
		const { CURRENT_SESSION } = this.props;
		// console.log(this.props);
		return (
			<div>
			{isAuthenticated &&
				<BottomNavigation
					value={selected}
					onChange={this.setValue}
					showLabels
					style={{ backgroundColor: "#b9d2cecf", width:"100%", zIndex: 10000, position: 'relative'}}
					// className={classes.root}
				>
					<BottomNavigationAction label="Dépenses" icon={<RestoreRounded />} />
					{isAdmin &&
						<BottomNavigationAction label="Admin" icon={<InsertChartOutlinedRounded />} />
					}
					<BottomNavigationAction label="Materiel" icon={<PlumbingRounded />} />
					{!isEmpty(employee) &&
						<BottomNavigationAction label="Salaires" icon={<ListAltRounded />} />
					}
					{!isEmpty(employee) &&
						<BottomNavigationAction label="Planning" icon={<CalendarTodayRounded />} />
					}
					{/* {!isEmpty(employee) &&
					} */}
					{!isEmpty(employee) && !isEmpty(CURRENT_SESSION) &&
						<BottomNavigationAction label="Demandes" icon={<QuizRounded />} />
					}
				</BottomNavigation>
			}

			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		auth: state.auth,
	};
}

export default connect( mapStateToProps )(Footer)